import { BaseWorkflowRuleCollection } from '@/modules/workflow/models/BaseWorkflowRuleCollection';
import { WorkflowJurisdictionRule } from '@/modules/workflow/models/WorkflowJurisdictionRule';
import { Jurisdiction } from '/@/modules/predefined/models/Jurisdiction';
import Lang from '@/modules/core/app/services/Lang';
import { WorkflowRuleType } from '/@/modules/workflow/enums/WorkflowRuleType';

export class WorkflowJurisdictionRuleCollection extends BaseWorkflowRuleCollection<WorkflowJurisdictionRule> {
  constructor(items: WorkflowJurisdictionRule[] | WorkflowJurisdictionRuleCollection | undefined) {
    super(items, WorkflowJurisdictionRule);
  }

  static mapModel(
    items: WorkflowJurisdictionRule[] | WorkflowJurisdictionRuleCollection | undefined
  ): WorkflowJurisdictionRuleCollection {
    return new this(items);
  }

  get jurisdictions(): Array<Jurisdiction | undefined> {
    return (
      this.items?.map(
        (jurisdictionRule: WorkflowJurisdictionRule): Jurisdiction | undefined =>
          jurisdictionRule.jurisdiction
      ) ?? []
    );
  }

  sync(jurisdictionSelection: Jurisdiction[]): void {
    super.syncRules(
      jurisdictionSelection.map(
        (jurisdiction: Jurisdiction): WorkflowJurisdictionRule =>
          WorkflowJurisdictionRule.mapModel({
            jurisdictionId: jurisdiction.id,
            jurisdiction: jurisdiction
          })
      )
    );
  }

  get ruleText(): string {
    return this.count > 1 ? Lang.t('workflow.jurisdiction-in') : Lang.t('workflow.jurisdiction-is');
  }

  get ruleType(): string {
    return WorkflowRuleType.JURISDICTION.key;
  }

  get ruleSelection(): Jurisdiction[] {
    return this.jurisdictions as Jurisdiction[];
  }
}
